import { UserModel } from '$tablet-app/src/app/auth/UserModel';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { palette } from '$tablet-app/src/app/theme';
import { User } from '@akin-home/amplify';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import { StickyNote } from '../types';
import StickyNoteSheet from './StickyNoteSheet';
interface Props {
  notes: StickyNote[];
  current_user: UserModel;
  users?: User[];
  onPressAddNew?: () => void;
  onPress: (note: StickyNote) => void;
  onDelete?: (id: string) => void;
  onPressAcknowledge?: (note: StickyNote) => void;
  onUpdateColor?: (note: StickyNote) => void;
  onPressEdit?: (note: StickyNote) => void;
  onSave: (note: StickyNote) => void;
}

const ManageStickyNoteGrid = (props: Props) => {
  const {
    notes,
    current_user,
    users,
    onPress,
    onPressAcknowledge,
    onPressEdit,
    onPressAddNew,
    onDelete,
  } = props;

  const handleDelete = (note: StickyNote) => onDelete?.(note.id);

  return (
    <ScrollView>
      <Row flexWrap="wrap">
        {onPressAddNew ? (
          <AddNewBlock onPress={onPressAddNew}>
            <Text variant="stickyNote">"Add note"</Text>

            <Spacer height="32px" />

            <PlusButton>
              <FontAwesomeIcon icon="plus" size={24} />
            </PlusButton>
          </AddNewBlock>
        ) : null}

        {notes.map((note) => (
          <StyledStickyNote
            key={note.id}
            sticky_note={note}
            current_user={current_user}
            users={users}
            onPress={onPress}
            onPressDelete={handleDelete}
            onPressEdit={onPressEdit}
            onPressAcknowledge={onPressAcknowledge}
          />
        ))}
      </Row>
    </ScrollView>
  );
};

const StickyNoteTileBase = styled.TouchableOpacity`
  flex: 1 0 320px;
  max-width: 320px;
  width: 320px;
  height: 320px;
  border-radius: 15px;
  align-items: center;

  margin-right: 34px;
`;

const AddNewBlock = styled(StickyNoteTileBase)`
  background-color: ${palette.Background_blue};
  justify-content: center;
  margin-bottom: 30px;
  border: 2px dashed #d0d0d0;
`;

const PlusButton = styled.View`
  height: 54px;
  width: 54px;
  border-radius: 22px;
  background-color: rgba(5, 22, 51, 0.1);
  align-items: center;
  justify-content: center;
`;
const StyledStickyNote = styled(StickyNoteSheet)`
  height: 320px;
  width: 320px;

  margin: 0px 34px 34px 0px;
`;

export default ManageStickyNoteGrid;
